import { Option } from '@organisms/Select'

export const SCHOOL_VALUE = 'school'

type CourseAuthorData = {
  isClientCourse?: boolean
  ownerCompany?: {
    id: number
  }
}

export const isCourseMatchingAuthor = (
  course: CourseAuthorData,
  courseAuthor?: Option
): boolean => {
  if (!courseAuthor) return true

  if (courseAuthor.value === SCHOOL_VALUE) {
    return !course.isClientCourse
  }

  return (
    course.isClientCourse === true &&
    course.ownerCompany?.id.toString() === courseAuthor.value.toString()
  )
}
